// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"7564eb97","63":"f04eb706","66":"5343bbda","124":"f28bfdfd","331":"e2c16f2e","390":"362bac59","527":"dd653a59","578":"332805e7","591":"643722eb","672":"d4ebdcef","804":"2e2c8ebe","907":"a2b4324e","908":"6c9be24a","972":"c4ad41bf"}[chunkId] + ".chunk.js";
};